import styled from '@emotion/styled';
import { useContext } from 'react';
import { agentUserContext } from 'application/contexts/useAgentUser';
import { MeetingList } from './MeetingList';
import { AttentionCard } from './AttentionCard';
import { NewCompanyList } from './NewCompanyList';
import { NewBuyerList } from './NewBuyerList';
import { useDashboard } from './useDashboard';
import { PageTitle } from 'ui/components/elements/PageTitle/PageTitle';
import { mqUser } from 'utils/responsive';
import { CopyInvitationCodeButton } from 'ui/components/common/features/CopyInvitationCodeButton/CopyInvitationCodeButton';

const Wrapper = styled.div<{ loading: boolean }>`
    padding: 18px 50px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: left;
    background-color: #f8f9fd;
    height: auto;
    min-height: calc(100vh - var(--height-pc-header));
    overflow-y: auto;

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    animation: ${({ loading }) => (loading ? 'none' : 'fadeIn 0.2s ease-in-out')};

    ${mqUser('SP')} {
        padding: 18px 15px;
    }
`;

const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;

    ${mqUser('SP')} {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const Dashboard: React.FC = () => {
    const { loading, companies, buyers } = useDashboard();
    const { user, meetingDateSetMatchList, existsUnreadMsg, isMeetingDateNotSet } = useContext(agentUserContext);
    const companyName = user?.agent?.name || '仲介会社';
    let attentionList = [];
    if (existsUnreadMsg) {
        attentionList.push({
            text: '未読のメッセージがあります。',
            link: '/agent/message/',
        });
    }
    if (isMeetingDateNotSet) {
        attentionList.push({
            text: '面談日が未設定の企業があります。「メッセージ」から面談日を設定してください。',
            link: '/agent/message/',
        });
    }

    return (
        <Wrapper loading={loading}>
            {isMeetingDateNotSet && <AttentionCard attentionList={attentionList} />}
            <HeaderWrapper>
                <PageTitle title={`${companyName}様マイページ`} />
                {user?.invitation_code && <CopyInvitationCodeButton invitationCode={user.invitation_code} />}
            </HeaderWrapper>
            <MeetingList matches={meetingDateSetMatchList} />
            <NewCompanyList companies={companies} />
            <NewBuyerList buyers={buyers} />
        </Wrapper>
    );
};
